import { render, staticRenderFns } from "./MemberAddressTab.vue?vue&type=template&id=5ae3ecbc&"
import script from "./MemberAddressTab.vue?vue&type=script&lang=js&"
export * from "./MemberAddressTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports